import { EventEmitter } from 'events'
import { Map } from 'immutable'
import { format } from 'date-fns'
import ru from 'date-fns/locale/ru'
import Dispatcher from 'core/Dispatcher'
import Actions from 'constants/Actions'
import RouteStore from 'stores/RouteStore'
import ParametersStore from 'stores/ParametersStore'
import GeneralStore from 'stores/GeneralStore'
import UserStore from 'stores/UserStore'
import CategoryStore from 'stores/CategoryStore'
import CargosConstants from 'constants/Cargos'
import {
    TYPE_FIXED_DATE_WITH_DRIVER,
    TYPE_FLEXIBLE_DATE_WITH_DRIVER,
    TYPE_FIXED_DATE_WITH_LOADERS,
} from 'constants/Instantprices'
import ParamConstants from 'constants/Parameters'
import { validate } from 'api'
import ActionCreators from '../actions/ActionCreators'
import { isPast } from 'date-fns'

const CHANGE_EVENT = 'change'

const REGIONS_FOR_INSTANT_BOOKING = [
    'Москва',
    'Московская область', 'Московская',
    'Санкт-Петербург', 'Ленинградская область', 'Ленинградская',
    'Ростовская область', 'Ростовская',
    'Краснодарский край', 'Краснодарский',
    'Ставропольский край', 'Ставропольский',
    'Волгоградская область', 'Волгоградская',
    'Белгородская область', 'Белгородская',
    'Воронежская область', 'Воронежская',
    'Самарская область', 'Самарская',
    'Саратовская область', 'Саратовская',
    'Рязанская область', 'Рязанская',
    'Нижегородская область', 'Нижегородская',
    'Республика Татарстан', 'Татарстан',
    'Республика Башкортостан', 'Башкортостан',
    'Челябинская область', 'Челябинская',
    'Свердловская область', 'Свердловская',
    'Вологодская область', 'Вологодская',
    'Калужская область', 'Калужская',
    'Тверская область', 'Тверская',
    'Смоленская область', 'Смоленская',
    'Ивановская область', 'Ивановская',
    'Владимирская область', 'Владимирская',
    'Ярославская область', 'Ярославская',
    'Липецкая область', 'Липецкая',
]

// внутрирегиональные
const INTRAREGIONALS = [
    'Ростовская',
    'Краснодарский',
    'Ставропольский',
    'Волгоградская',
    'Белгородская',
    'Воронежская',
    // 'Самарская',
    // 'Саратовская',
    'Рязанская',
    'Нижегородская',
    // 'Татарстан',
    'Башкортостан',
    'Челябинская',
    // 'Свердловская',
    'Вологодская',
    'Калужская',
    'Тверская',
    'Смоленская',
    'Ивановская',
    'Владимирская',
    'Ярославская',
    'Липецкая',
]

// внутрирегиональные и межрегиональные (каждый с каждым)
const INTERREGIONALS_INTRAREGIONALS = [
    'Москва',
    'Московская',
    // 'Санкт-Петербург',
    // 'Ленинградская',
]

// Москва+Московская область - остальные регионы
const MSK_REGIONS = [
    'Москва',
    'Московская',
]
const MSK_OTHER_REGIONS = [
    'Калужская',
    'Тверская',
    'Смоленская',
    'Ивановская',
    'Владимирская',
    'Ярославская',
    'Липецкая',
    'Воронежская',
    'Ростовская',
    'Краснодарский',
    'Ленинградская',
    'Санкт-Петербург'
]

const _state = {
    prices: Map({}),
    services: Map({}),
    type: TYPE_FIXED_DATE_WITH_DRIVER,
    show_by_category: false,
    show_by_route: false,
    show_by_query_param: false,
    price: 0,
    basePrice: 0,
    partDay: Map({}),
    timeIsSelected: false,
    distance: 0,
    normalized_data: {},
    show_instant_booking_spinner: true,
    show_go_to_auction_button: true,
    email_completed: false,
    hash: '',
    hash_log_mode: false,
    dumped_loaders: null,
    debug_data: {},
    show_away_modal: false,
    promocode: '',
    promocode_amount: 0,
    analytics_route_visit_param: '',
    loaders_saved: true,
    loaders_expanded: false,
    googleMapRoute: null
}

function setInstantBookingType(type) {
    _state.type = type
}

function setInstantBookingPrice(price) {
    _state.price = price
}

function selectInstantBookingPartDay(partDay) {
    _state.partDay = Map(partDay)
}

function setTimeIsSelected(value) {
    _state.timeIsSelected = value
}

function setInstantBookingPrices(prices) {
    _state.prices = Map(prices)
}

function setInstantBookingServices(services) {
    _state.services = Map(services)
}

function showInstantBookingByCategory(categoryName) {
    if (categoryName === 'household' ||
        categoryName === 'moving' ||
        categoryName === 'passing' ||
        categoryName === 'book_separate_car' ||
        categoryName === 'commercial' ||
        categoryName === 'building' ||
        categoryName === 'special'
    ) {
        _state.show_by_category = true
    } else {
        _state.show_by_category = false
        _state.price = 0
    }
}

function setAnalyticsRouteVisitParam(locations) {
    let from = locations[0][1].region
    let to = locations[0][2].region

    from = from.replace('г ', '')
    to = to.replace('г ', '')

    return `${from.replace(' ', '_')}|${to.replace(' ', '_')}`
}

function showInstantBookingByRoute(normalizedLocations = []) {
    let locations = []
    if (normalizedLocations.length > 0) {
        locations = normalizedLocations
    } else {
        const state = {}
        RouteStore.normalizeState(state)
        locations = state.locations
    }

    if (!locations[0][1] || !locations[0][2]) {
        _state.show_by_route = false
        _state.price = 0
        return
    }

    let regionNameFrom = locations[0][1].region;
    let regionNameTo = locations[0][2].region;

    if (
        (locations[0][1] && !REGIONS_FOR_INSTANT_BOOKING.find(item => item === locations[0][1].region)) ||
        (locations[0][2] && !REGIONS_FOR_INSTANT_BOOKING.find(item => item === locations[0][2].region)) ||
        (locations[1][1] && !REGIONS_FOR_INSTANT_BOOKING.find(item => item === locations[1][1].region)) ||
        (locations[1][2] && !REGIONS_FOR_INSTANT_BOOKING.find(item => item === locations[1][2].region))
    ) {
        _state.show_by_route = false
        _state.price = 0
        return
    }

    const category = CategoryStore.getSelected();
    const stringRoute = setAnalyticsRouteVisitParam(locations);

    //внутрирегиональные перевозки

    let regexpRegionNameFrom = new RegExp(regionNameFrom, 'i');
    let regexpRegionNameTo = new RegExp(regionNameTo, 'i');
    if ((regexpRegionNameFrom.test(regexpRegionNameTo) || regexpRegionNameTo.test(regionNameFrom))
        &&
        (category.name === 'household' || category.name === 'moving' || category.name === 'book_separate_car' || category.name === 'passing' || category.name === 'building' || category.name === 'commercial' || category.name === 'special')
    ) {
        let isReturn = false;
        INTRAREGIONALS.forEach(function (item) {
            let regexp = new RegExp(item, 'i');
            if (regexp.test(regionNameFrom)) {
                isReturn = true;
                return;
            }
        });
        if (isReturn) {
            _state.analytics_route_visit_param = stringRoute;
            _state.show_by_route = true;
            return;
        }
    }

    //межрегиональные и внутрирегиональные
    let isReturnFrom = false;
    let isReturnTo = false;
    INTERREGIONALS_INTRAREGIONALS.forEach(function (item) {
        let regexp = new RegExp(item, 'i');
        if (regexp.test(regionNameFrom))
            isReturnFrom = true;
        if (regexp.test(regionNameTo))
            isReturnTo = true;
    });

    if (isReturnFrom && isReturnTo) {
        _state.analytics_route_visit_param = stringRoute;
        _state.show_by_route = true;
        return;
    }

    // Москва+Московская область - остальные регионы
    let isReturnMSK = false;
    let isReturnMSKOthers = false;
    MSK_REGIONS.forEach(function (item) {
        let regexp = new RegExp(item, 'i');
        if (regexp.test(regionNameFrom))
            isReturnMSK = true;
        if (regexp.test(regionNameTo))
            isReturnMSK = true;
    });
    MSK_OTHER_REGIONS.forEach(function (item) {
        let regexp = new RegExp(item, 'i');
        if (regexp.test(regionNameFrom))
            isReturnMSKOthers = true;
        if (regexp.test(regionNameTo))
            isReturnMSKOthers = true;
    });
    if (isReturnMSK && isReturnMSKOthers) {
        _state.analytics_route_visit_param = stringRoute;
        _state.show_by_route = true;
        return;
    }

    _state.show_by_route = false;
    _state.price = 0;
}

function setInstantBookingCarNormalizedData(data) {
    _state.normalized_data = data
}

function showInstantBookingByQueryParam() {
    _state.show_by_query_param = true
}

function hideInstantBookingByQueryParam() {
    _state.show_by_query_param = false
}

function setInstantPriceDistance(distance) {
    _state.distance = distance
}

function setInstantGoogleMapRoute(route) {
    _state.googleMapsRoute = route
}

function blockInstantBookingSpinner() {
    _state.show_instant_booking_spinner = false
}

function setInstantBookingHash(hash) {
    _state.hash = hash
}

function calculateInstantBookingPrice() {
    const parameters = ParametersStore.getDeliveryParameters()
    const dates = RouteStore.getDates()
    let price = 0

    switch (_state.type) {
        case TYPE_FLEXIBLE_DATE_WITH_DRIVER:
            if (dates.from) {
                const day = _state.prices.get(format(dates.from, 'YYYY-MM-DD', { locale: ru }))
                price = day.date_desc.flex_price
            }
            break
        default:
            if (_state.partDay.size > 0) {
                price = _state.partDay.valueSeq().get(0).price
            }
            break
    }

    price = Object.keys(parameters).reduce((result, key) => {
        const priceCoef = parameters[key].get('price_coef')

        if (priceCoef && parameters[key].get('value')) {
            return Math.ceil(priceCoef * result)
        }

        return result
    }, price)

    const parametersPrice = Object.keys(parameters).reduce((result, key) => {
        const price = parameters[key].get('price')

        if (price && parameters[key].get('name') === 'escort' && parameters[key].get('value')) {
            return result + price * parameters[key].get('value')
        } else if (price && parameters[key].get('value')) {
            return result + price
        }

        return result
    }, 0)

    if (!price) {
        price = 0
    }

    _state.price = price + parametersPrice
    _state.basePrice = price;
    //_state.price = Math.ceil((price + parametersPrice) * 1.1)
    //_state.basePrice = Math.ceil(price * 1.1)

    if (parameters.payment_cash.get('value')) {
        _state.price = _state.price + Math.ceil(_state.price * 0.1)
    }


    _state.price = _state.price - _state.promocode_amount
}

function completeEmail() {
    _state.email_completed = true
}

function instantBookingHashLogModeOn() {
    _state.hash_log_mode = true
}

function toggleInstantBookingLoaders(checked) {
    if (!checked) {
        const result = {}
        let dumpedLoaders = {}

        ParametersStore.normalizeState(result)

        Object.keys(result.params).forEach(id => {
            switch (id) {
                case '11':
                    if (result.params[11]) {
                        dumpedLoaders.loaders = true
                    }
                    break
                case '50':
                    if (result.params[50]) {
                        dumpedLoaders.load_loaders = true
                    }
                    break
                case '51':
                    if (result.params[51]) {
                        dumpedLoaders.unload_loaders = true
                    }
                    break
                case '14':
                    if (result.params[14]) {
                        dumpedLoaders.load_elevator = result.params[14]
                    }
                    break
                case '15':
                    if (result.params[15]) {
                        dumpedLoaders.unload_elevator = result.params[15]
                    }
                    break
                case '12':
                    if (result.params[12]) {
                        dumpedLoaders.load_floor = result.params[12]
                    }
                    break
                case '13':
                    if (result.params[13]) {
                        dumpedLoaders.unload_floor = result.params[13]
                    }
                    break
            }
        })

        if (Object.keys(dumpedLoaders).length > 0) {
            _state.dumped_loaders = dumpedLoaders
        }
    } else {
        _state.dumped_loaders = null
    }
}

function setDebugData(data) {
    _state.debug_data = data
}

function hideInstantBookingGoToAuctionButton() {
    _state.show_go_to_auction_button = false
}

function showInstantBookingGoToAuctionButton() {
    _state.show_go_to_auction_button = true
}

function showInstantBookingAwayModal() {
    _state.show_away_modal = true
}

function hideInstantBookingAwayModal() {
    _state.show_away_modal = false
}

function setInstantBookingPromocode(promocode, amount) {
    _state.promocode = promocode
    _state.promocode_amount = amount
}

function setLoadersExpanded(value) {
    _state.loaders_expanded = value
}

class InstantBookingStore extends EventEmitter {

    validate() {
        return validate().then(
            response => {
                const errors = response.params

                if (!errors) {
                    return Promise.resolve()
                }

                return Promise.reject(response)
            },
        )
    }

    /**
     * @param {function} callback
     */
    addChangeListener(callback) {
        this.on(CHANGE_EVENT, callback)
    }

    /**
     * @param {function} callback
     */
    removeChangeListener(callback) {
        this.removeListener(CHANGE_EVENT, callback)
    }

    getPrices() {
        return _state.prices
    }

    getServices() {
        return _state.services
    }

    getPrice() {
        return _state.price
    }

    getBasePrice() {
        return _state.basePrice;
    }

    getPartDay() {
        return _state.partDay
    }


    getTimeIsSelected() {
        return _state.timeIsSelected
    }

    getDateWasSelected() {
        return this.dateWasSelected || false;
    }

    setDateWasSelected(value) {
        this.dateWasSelected = value;
        this.emitChange();
    }


    getLoadersExpanded() {
        return _state.loaders_expanded
    }

    getDistance() {
        return _state.distance
    }

    getGoogleMapsRoute() {
        return _state.googleMapsRoute
    }

    getType() {
        return _state.type
    }

    getHash() {
        return _state.hash
    }

    getDumpedLoaders() {
        return _state.dumped_loaders
    }

    getDebugData() {
        return _state.debug_data
    }

    getPromocodeAmount() {
        return _state.promocode_amount
    }

    getSelectedPaymentTypeName() {
        const parameters = ParametersStore.getDeliveryParameters()

        if (parameters.payment_online && parameters.payment_online.get('value')) {
            return parameters.payment_online.get('name')
        }

        if (parameters.payment_invoice && parameters.payment_invoice.get('value')) {
            return parameters.payment_invoice.get('name')
        }

        if (parameters.payment_cash && parameters.payment_cash.get('value')) {
            return parameters.payment_cash.get('name')
        }

        if (parameters.payment_prepay && parameters.payment_prepay.get('value')) {
            return parameters.payment_prepay.get('name')
        }

        return parameters.payment_online ? parameters.payment_online.get('name') : ''
    }

    getAnalyticsRouteVisitParams() {
        return _state.analytics_route_visit_param
    }

    isInHashLogMode() {
        return _state.hash_log_mode === true
    }

    
    showInstantBooking() {
        return _state.show_by_category && _state.show_by_route && GeneralStore.isAddMode()
    }

    showLoader() {
        return _state.show_instant_booking_spinner === true
    }

    emailCompleted() {
        return _state.email_completed === true
    }

    showGoToAuctionButton() {
        return _state.show_go_to_auction_button === true
    }

    showAwayModal() {
        return _state.show_away_modal === true
    }

    isLoadersSaved() {
        return _state.loaders_saved === true
    }

    normalizeState(result, isLocations = false) {
        result.instant_booking_car_data = _state.normalized_data
        result.price = _state.price

        if (isLocations) {
            result.locations_points = this.collectLocationData(result).points;
        }

        if (_state.partDay.size > 0) {
            result.part_day = _state.partDay.toJS()
        }

        result.price_type = _state.type

        const parameters = ParametersStore.getDeliveryParameters()
        const price_services = []
        Object.keys(parameters).forEach(key => {
            const price = parameters[key].get('price')
            const priceCoef = parameters[key].get('price_coef')

            if ((price && parameters[key].get('value')) || (priceCoef && parameters[key].get('value'))) {
                price_services.push(parameters[key].get('name'))
            }
        })

        result.price_services = price_services
        result.price_hash = _state.hash
        result.price_distance = _state.distance

        result.promocode = _state.promocode
        result.promocode_amount = parseInt(_state.promocode_amount, 10)

        if (parameters.escort && parameters.escort.get('value') > 0) {
            result.instant_booking_car_data.count_escort = parameters.escort.get('value')
        }

        return result
    }

    collectDataToGetServicePrices() {
        const data =  GeneralStore.getNormalizedState()
        let result = {}

        result.order = {
            total_stuff_volume: data.total_volume ? data.total_volume : 0,
            locations_points: this.collectLocationData(data).points,
            is_packing: true,
            is_rigging: true,
            is_escort: true,

        }

        if (data.params[ParamConstants.LOADERS_PARAMS.LOAD_LOADERS]) {
            result.load = {}

            if (data.params[ParamConstants.LOADERS_PARAMS.LOAD_LOADERS_COUNT]) {
                result.load.loaders_count = data.params[ParamConstants.LOADERS_PARAMS.LOAD_LOADERS_COUNT]
            }

            if (data.params[ParamConstants.LOADERS_PARAMS.LOAD_FLOOR]) {
                result.load.floor = data.params[ParamConstants.LOADERS_PARAMS.LOAD_FLOOR]
            }

            if (data.params[ParamConstants.LOADERS_PARAMS.LOAD_ELEVATOR]) {
                result.load.elevator_type = data.params[ParamConstants.LOADERS_PARAMS.LOAD_ELEVATOR]
            }
        }

        if (data.params[ParamConstants.LOADERS_PARAMS.UNLOAD_LOADERS]) {
            result.unload = {}

            if (data.params[ParamConstants.LOADERS_PARAMS.UNLOAD_LOADERS_COUNT]) {
                result.unload.loaders_count = data.params[ParamConstants.LOADERS_PARAMS.UNLOAD_LOADERS_COUNT]
            }

            if (data.params[ParamConstants.LOADERS_PARAMS.UNLOAD_FLOOR]) {
                result.unload.floor = data.params[ParamConstants.LOADERS_PARAMS.UNLOAD_FLOOR]
            }

            if (data.params[ParamConstants.LOADERS_PARAMS.UNLOAD_ELEVATOR]) {
                result.unload.elevator_type = data.params[ParamConstants.LOADERS_PARAMS.UNLOAD_ELEVATOR]
            }
        }

        return result;
    }

    collectDataToGetPrices() {
        const data = GeneralStore.getNormalizedState()
        const user = UserStore.getUser()
        let result = {}
        const truckIds = []
        const loadTypeIds = []

        return ActionCreators.calibrateNormalizedLocations(data.locations)
            .then(calibratedLocations => {
                if (calibratedLocations) {
                    data.locations = calibratedLocations
                } else {
                    data.locations = _state.normalized_data.locations
                }

                // Collect cargo dimensions
                const items = data.stuff.reduce((result, stuff) => {
                    let item = {}

                    if (stuff.attributes[CargosConstants.ATTRIBUTE_NOT_FIT_ELEVATOR]) {
                        item.not_fit_elevator = 1
                    }

                    if (stuff.attributes[CargosConstants.ATTRIBUTE_UNITS] &&
                        stuff.attributes[CargosConstants.ATTRIBUTE_UNITS][0]) {
                        const units = stuff.attributes[CargosConstants.ATTRIBUTE_UNITS][0]

                        item.weight = stuff.attributes[CargosConstants.ATTRIBUTE_WEIGHT] > 0 ?
                            stuff.attributes[CargosConstants.ATTRIBUTE_WEIGHT] : -999

                        if (units === CargosConstants.UNITS.KG) {
                            item.weight = item.weight / 1000
                        }

                        item.length = stuff.attributes[CargosConstants.ATTRIBUTE_LENGTH] > 0 ?
                            stuff.attributes[CargosConstants.ATTRIBUTE_LENGTH] : -999

                        item.width = stuff.attributes[CargosConstants.ATTRIBUTE_WIDTH] > 0 ?
                            stuff.attributes[CargosConstants.ATTRIBUTE_WIDTH] : -999

                        item.hight = stuff.attributes[CargosConstants.ATTRIBUTE_HEIGHT] > 0 ?
                            stuff.attributes[CargosConstants.ATTRIBUTE_HEIGHT] : -999

                        if (units === CargosConstants.UNITS.CM) {
                            item.length = item.length / 100
                            item.width = item.width / 100
                            item.hight = item.hight / 100
                        }
                    }

                    if (stuff.attributes[CargosConstants.ATTRIBUTE_QUANTITY]) {
                        item.count_items = stuff.attributes[CargosConstants.ATTRIBUTE_QUANTITY]
                    } else {
                        item.count_items = 1
                    }

                    if (Object.keys(item).length === 0) {
                        return result
                    }

                    result.push(item)

                    return result
                }, [])

                let time_predict = ''
                if (data.dates && data.dates.calendarStartDate /* && !isPast(data.dates.calendarStartDate)*/) {
                    time_predict = data.dates.calendarStartDate
                }
                // else
                //     if (data.dates && data.dates.date_from && !isPast(data.dates.date_from)) {
                //         time_predict = data.dates.date_from
                //     }
                else {
                    time_predict = new Date()
                }

                result.time_predict = format(time_predict, 'YYYY-MM-DD HH:mm:ss', { locale: ru })

                if (items.length > 0) {
                    result.items = items
                }

                if (user.email.value) {
                    result.email = user.email.value
                }
                result.count_days = 50
                result.category_id = data.category_id
                result.all_weight = data.total_weight ? data.total_weight / 1000 : -999
                result.all_volume = data.total_volume ? data.total_volume : -999
                result.stuff_type_id = data.stuff[0].stuff_type_id
                result.stuff_predefined_id = data.stuff[0].id ? data.stuff[0].id : -999

                // Collect escort
                if (data.params[ParamConstants.ESCORT]) {
                    result.count_escort = data.params[ParamConstants.ESCORT]
                } else {
                    result.count_escort = 1
                }

                // Collect round trip
                // if (data.params[ParamConstants.ROUND_TRIP]) {
                //     result.round_trip = data.params[ParamConstants.ROUND_TRIP]
                // } else {
                //     result.round_trip = 0
                // }

                // Truck body
                if (data.params[ParamConstants.TRUCK_BODY_TYPE_OPEN_ID]) {
                    data.params[ParamConstants.TRUCK_BODY_TYPE_OPEN_ID].map(truckId => truckIds.push(truckId))
                }

                if (data.params[ParamConstants.TRUCK_BODY_TYPE_CLOSE_ID]) {
                    data.params[ParamConstants.TRUCK_BODY_TYPE_CLOSE_ID].map(truckId => truckIds.push(truckId))
                }

                if (data.params[ParamConstants.TRUCK_BODY_TYPE_TEMP_ID]) {
                    data.params[ParamConstants.TRUCK_BODY_TYPE_TEMP_ID].map(truckId => truckIds.push(truckId))
                }

                if (data.params[ParamConstants.TRUCK_BODY_TYPE_OUTSIZED_ID]) {
                    data.params[ParamConstants.TRUCK_BODY_TYPE_OUTSIZED_ID].map(truckId => truckIds.push(truckId))
                }

                if (data.params[ParamConstants.TRUCK_BODY_TYPE_PASSENGER_ID]) {
                    data.params[ParamConstants.TRUCK_BODY_TYPE_PASSENGER_ID].map(truckId => truckIds.push(truckId))
                }

                if (data.params[ParamConstants.TRUCK_BODY_TYPE_OTHER_ID]) {
                    data.params[ParamConstants.TRUCK_BODY_TYPE_OTHER_ID].map(truckId => truckIds.push(truckId))
                }

                if (truckIds.length > 0) {
                    result.truck_type_ids = truckIds
                }

                if (data.params[ParamConstants.LOAD_TYPE_ID]) {
                    data.params[ParamConstants.LOAD_TYPE_ID].map(loadTypeId => loadTypeIds.push(loadTypeId))
                }

                if (loadTypeIds.length > 0) {
                    result.load_type_ids = loadTypeIds
                }

                if (data.params[ParamConstants.LOADERS_PARAMS.LOAD_LOADERS] || data.params[ParamConstants.LOADERS_PARAMS.UNLOAD_LOADERS]) {
                    result.count_loader = _state.services.get('price_loader') ? _state.services.get('price_loader').count_loader : 2

                    if (data.params[ParamConstants.LOADERS_PARAMS.LOAD_LOADERS]) {
                        if (data.params[ParamConstants.LOADERS_PARAMS.LOAD_FLOOR]) {
                            result.floor_load = data.params[ParamConstants.LOADERS_PARAMS.LOAD_FLOOR]
                        }

                        if (data.params[ParamConstants.LOADERS_PARAMS.LOAD_ELEVATOR]) {
                            switch (data.params[ParamConstants.LOADERS_PARAMS.LOAD_ELEVATOR][0]) {
                                case ParamConstants.LOAD_ELEVATOR_TYPES.NO:
                                    result.lift_pass_load = 0
                                    result.lift_truck_load = 0
                                    break
                                case ParamConstants.LOAD_ELEVATOR_TYPES.PASSENGER:
                                    result.lift_pass_load = 1
                                    break
                                case ParamConstants.LOAD_ELEVATOR_TYPES.SERVICE:
                                    result.lift_truck_load = 1
                                    break
                            }
                        }
                    }

                    // Stevedores for unloading
                    if (data.params[ParamConstants.LOADERS_PARAMS.UNLOAD_LOADERS]) {
                        if (data.params[ParamConstants.LOADERS_PARAMS.UNLOAD_FLOOR]) {
                            result.floor_unload = data.params[ParamConstants.LOADERS_PARAMS.UNLOAD_FLOOR]
                        }

                        if (data.params[ParamConstants.LOADERS_PARAMS.UNLOAD_ELEVATOR]) {
                            switch (data.params[ParamConstants.LOADERS_PARAMS.UNLOAD_ELEVATOR][0]) {
                                case ParamConstants.UNLOAD_ELEVATOR_TYPES.NO:
                                    result.lift_pass_unload = 0
                                    result.lift_truck_unload = 0
                                    break
                                case ParamConstants.UNLOAD_ELEVATOR_TYPES.PASSENGER:
                                    result.lift_pass_unload = 1
                                    break
                                case ParamConstants.UNLOAD_ELEVATOR_TYPES.SERVICE:
                                    result.lift_truck_unload = 1
                                    break
                            }
                        }
                    }
                }

                const locationData = this.collectLocationData(data)

                result.locations_points = locationData.points
                result.locations_data = locationData.prepared_locations

                if (data.price_distance) {
                    result.distance = data.price_distance
                }

                result.state_dump = GeneralStore.getNormalizedState()

                setInstantBookingCarNormalizedData(result)

                return result
            }).catch(error => console.error(error))
    }

    collectLocationData(data) {
        if ((!data.locations[0][1] || !data.locations[0][2]) && (!data.locations[1][1] || !data.locations[1][2])) {
            return {
                points: [],
                prepared_locations: [],
            }
        }

        let points = [];
        let locations = [];

        if (
            data.locations[0] &&
            Object.keys(data.locations[0]).length > 0 &&
            data.locations[0][1] &&
            Object.keys(data.locations[0][1]).length > 0
        ) {
            const currentLocations = data.locations[0][1];

            points = [data.locations[0][1].coords.slice().reverse()]

            if (currentLocations.country && currentLocations.region && currentLocations.city) {
                locations = [{
                    country_id_from: data.locations[0][1].country,
                    region_from: data.locations[0][1].region,
                    city_from: data.locations[0][1].city,
                }]
            }
        }

        const prepared_locations = []

        if (
            data.locations[1] &&
            Object.keys(data.locations[1]).length > 0 &&
            data.locations[1][1] &&
            Object.keys(data.locations[1][1]).length > 0
        ) {
            const currentLocations = data.locations[1][1];

            points.push(data.locations[1][1].coords.slice().reverse())

            if (currentLocations.country && currentLocations.region && currentLocations.city) {
                locations.push({
                    country_id_to: data.locations[1][1].country,
                    region_to: data.locations[1][1].region,
                    city_to: data.locations[1][1].city,
                })

                locations.push({
                    country_id_from: data.locations[1][1].country,
                    region_from: data.locations[1][1].region,
                    city_from: data.locations[1][1].city,
                })
            }
        }

        if (
            data.locations[0] &&
            Object.keys(data.locations[0]).length > 0 &&
            data.locations[0][2] &&
            Object.keys(data.locations[0][2]).length > 0
        ) {
            const currentLocations = data.locations[0][2];

            points.push(data.locations[0][2].coords.slice().reverse())

            if (currentLocations.country && currentLocations.region && currentLocations.city) {
                locations.push({
                    country_id_to: data.locations[0][2].country,
                    region_to: data.locations[0][2].region,
                    city_to: data.locations[0][2].city,
                })

                locations.push({
                    country_id_from: data.locations[0][2].country,
                    region_from: data.locations[0][2].region,
                    city_from: data.locations[0][2].city,
                })
            }
        }

        if (
            data.locations[1] &&
            Object.keys(data.locations[1]).length > 0 &&
            data.locations[1][2] &&
            Object.keys(data.locations[1][2]).length > 0
        ) {
            const currentLocations = data.locations[1][2];

            points.push(data.locations[1][2].coords.slice().reverse())

            if (currentLocations.region && currentLocations.city && currentLocations.country) {
                locations.push({
                    country_id_to: data.locations[1][2].country,
                    region_to: data.locations[1][2].region,
                    city_to: data.locations[1][2].city,
                })
            }
        }

        for (let index = 1; index < locations.length; index += 2) {
            prepared_locations.push(Object.assign({}, locations[index - 1], locations[index]))
        }

        return {
            points,
            prepared_locations,
        }
    }

    denormalizeState(normalizedState) {
        if (normalizedState.price) {
            setInstantBookingPrice(parseInt(normalizedState.price, 10))
        }

        if (normalizedState.price_distance) {
            setInstantPriceDistance(normalizedState.price_distance)
        }

        if (normalizedState.price &&
            normalizedState.dates &&
            normalizedState.dates.date_from &&
            normalizedState.dates.date_to &&
            normalizedState.time &&
            normalizedState.time.time_from &&
            normalizedState.time.time_to) {
            selectInstantBookingPartDay({
                [`${normalizedState.time.time_from}-${normalizedState.time.time_to}`]: {
                    dt_start: `${normalizedState.dates.date_from}T${normalizedState.time.time_from}:00`,
                    dt_end: `${normalizedState.dates.date_to}T${normalizedState.time.time_to}:00`,
                },
            })
        }

        _state.show_by_category = true
        _state.show_by_route = true
        _state.show_by_query_param = true

        if (normalizedState.params && (normalizedState.params[ParamConstants.LOADERS_PARAMS.LOAD_LOADERS] || normalizedState.params[ParamConstants.LOADERS_PARAMS.UNLOAD_LOADERS])) {
            _state.type = TYPE_FIXED_DATE_WITH_LOADERS
        }
    }

    emitChange() {
        this.emit(CHANGE_EVENT)
    }

    dispatchToken = Dispatcher.register((action) => {

        const { payload } = action

        switch (action.type) {
            case Actions.SET_CALENDAR_TYPE:
                setInstantBookingType(payload.type)
                break
            case Actions.SELECT_CATEGORY:
                showInstantBookingByCategory(payload.categoryId)
                break
            case Actions.UPDATE_LOCATIONS:
                Dispatcher.waitFor([RouteStore.dispatchToken])
                showInstantBookingByRoute()
                break
            case Actions.SET_INSTANT_BOOKING_PRICE:
                setInstantBookingPrice(payload.price)
                break
            case Actions.SELECT_INSTANT_BOOKING_PART_DAY:
                selectInstantBookingPartDay(payload.partDay)
                break
            case Actions.SET_TIME_IS_SELECTED:
                setTimeIsSelected(payload.value);
                break
            case Actions.SET_INSTANT_PRICES:
                setInstantBookingPrices(payload.prices)
                break
            case Actions.SET_INSTANT_BOOKING_SERVICES:
                setInstantBookingServices(payload.services)
                break
            case Actions.SHOW_INSTANT_BOOKING_BY_QUERY_PARAM:
                showInstantBookingByQueryParam()
                break
            case Actions.HIDE_INSTANT_BOOKING_BY_QUERY_PARAM:
                hideInstantBookingByQueryParam()
                break
            case Actions.BLOCK_INSTANT_BOOKING_SPINNER:
                blockInstantBookingSpinner()
                break
            case Actions.CALCULATE_INSTANT_BOOKING_PRICE:
                Dispatcher.waitFor([
                    ParametersStore.dispatchToken,
                ])
                calculateInstantBookingPrice()
                break
            case Actions.COMPLETE_INSTANT_BOOKING_EMAIL:
                completeEmail()
                break
            case Actions.SET_INSTANT_BOOKING_HASH:
                setInstantBookingHash(payload.hash)
                break
            case Actions.SET_INSTANT_PRICE_DISTANCE:
                setInstantPriceDistance(payload.distance)
                break
            case Actions.SET_INSTANT_GOOGLE_MAPS_ROUTE:
                setInstantGoogleMapRoute(payload.route)
                break
            case Actions.INSTANT_BOOKING_HASH_LOG_MODE_ON:
                instantBookingHashLogModeOn()
                break
            case Actions.SHOW_INSTANT_BOOKING_BY_NORMALIZED_ROUTE:
                showInstantBookingByRoute(payload.normalizedLocations)
                _state.normalized_data.locations = payload.normalizedLocations
                break
            case Actions.TOGGLE_INSTANT_BOOKING_LOADERS:
                toggleInstantBookingLoaders(payload.value)
                break
            case Actions.SET_INSTANT_BOOKING_DEBUG_DATA:
                setDebugData(payload.data)
                break
            case Actions.HIDE_INSTANT_BOOKING_GO_TO_AUCTION_BUTTON:
                hideInstantBookingGoToAuctionButton()
                break
            case Actions.SHOW_INSTANT_BOOKING_GO_TO_AUCTION_BUTTON:
                showInstantBookingGoToAuctionButton()
                break
            case Actions.SHOW_INSTANT_BOOKING_AWAY_MODAL:
                showInstantBookingAwayModal()
                break
            case Actions.HIDE_INSTANT_BOOKING_AWAY_MODAL:
                hideInstantBookingAwayModal()
                break
            case Actions.SET_INSTANT_BOOKING_PROMOCODE:
                setInstantBookingPromocode(payload.promocode, payload.amount)
                break
            case Actions.SET_INSTANT_BOOKING_LOADERS_SAVED:
                _state.loaders_saved = payload.value
                break
            case Actions.SET_LOADERS_EXPANDED:
                setLoadersExpanded(payload.value)
                break
            default:
                return
        }

        this.emitChange()
    })

}

export default new InstantBookingStore()



// WEBPACK FOOTER //
// ./client/stores/InstantBookingStore.js